import { Color } from 'presentation/theme/colorScheme';
import { FontSize } from 'presentation/theme/fontSizes';

export enum InputVariant {
  filled = 'filled',
}

const inputTheme = {
  sizes: {
    md: {
      field: {
        height: '50px',
        fontSize: FontSize.md,
        fontWeight: 400,
        pl: '20px',
        pr: '20px',
      },
    },
  },
  variants: {
    [InputVariant.filled]: {
      field: {
        borderRadius: '6px',
        bgColor: Color.Background,

        _focus: {
          bgColor: Color.Background,
          borderColor: Color.Transparent,
        },

        _hover: {
          bgColor: Color.Background,
        },
      },
      icon: {
        color: Color.Primary500,
      },
    },
  },
};

export default inputTheme;
